import classNames from 'classnames';
import { Modal, ModalProps } from 'antd';
import { VscClose } from 'react-icons/vsc';
import { useAppContext } from '@/context';

import './styles.scss';
import { useLocaleStore } from '@/store';

export interface AppModalProps extends ModalProps {
  hide?: () => void;
  variant?: ComponentVariant;
}

export function AppModal({
  variant,
  children,
  className,
  ...rest
}: AppModalProps) {

  const { mode } = useAppContext();
  const dir = useLocaleStore(state => state.dir);

  return (
    <Modal
      onCancel={rest.hide}
      style={{ maxWidth: '90vw' }}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto', direction: dir } }}
      closeIcon={<VscClose style={{ fontSize: '1.5rem' }} />}
      className={classNames(`app-modal app-modal-${variant ?? mode}`, className)} {...rest}>
      {children}
    </Modal>
  );
}

export default AppModal;
